export enum AccaResultEnum {
  ACC_RESULT_TYPE = 'ACC_RESULT_TYPE',
  ACC_RECOMMEND_JOB_GROUP = 'ACC_RECOMMEND_JOB_GROUP',
}

export type AccaResultType = keyof typeof AccaResultEnum;

export const AccaResultTypeArray = [AccaResultEnum['ACC_RESULT_TYPE'], AccaResultEnum['ACC_RECOMMEND_JOB_GROUP']];
